import { connect } from "react-redux";
import NewWorkInstructionForm from "./NewWorkInstructionForm"
import { assignTags, fetchAllTags } from "../../../../redux/actions/tag_actions"
import { createWorkInstruction, editWorkInstruction, clearFormErrors, convertPDF} from "../../../../redux/actions/wi_actions"

import {uploadFile }  from "../../../../redux/actions/attachment_actions"

const mapStateToProps = (state) => {
    return ({
        tags: state.tags,
        workInstructions: state.work_instructions.all,
        errors: state.errors.wi,
        author: state.session.user.username
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        assignTags: payload => dispatch(assignTags(payload)),
        convertPDF: (fd, cb) => dispatch(convertPDF(fd, cb)),
        uploadPDF: (fd)=> dispatch(uploadFile(fd, true)),
        clearFormErrors: () => dispatch(clearFormErrors()),
        createWorkInstruction: (workInstructionPayload, path,clone) => dispatch(createWorkInstruction(workInstructionPayload, path,clone)),
        editWorkInstruction: WIID => dispatch(editWorkInstruction(WIID)),
        fetchAllTags: () => dispatch(fetchAllTags()), //2208222813
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(NewWorkInstructionForm);